var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height"},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('div',{staticClass:"viewer"},[_c('iframe',{attrs:{"src":_vm.lessonSrc,"frameborder":"0"}})])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }